/** Scroll only the transcript pane, leaving page/player position untouched. */
export function scrollTranscriptToActive(panel: HTMLElement, previousTarget: number | null): number | null {
  const active = panel.querySelector<HTMLElement>('.is-spoken') || panel.querySelector<HTMLElement>('.is-current .transcript-line-text') || panel.querySelector<HTMLElement>('.is-current')
  if (!active || !panel.clientHeight) return previousTarget
  const box = active.getBoundingClientRect(), viewport = panel.getBoundingClientRect()
  if (box.top >= viewport.top + 24 && box.bottom <= viewport.bottom - 40) return previousTarget
  const target = Math.max(0, Math.min(panel.scrollHeight - panel.clientHeight, panel.scrollTop + box.top - viewport.top - panel.clientHeight * .35))
  // Animation-frame playback updates must not restart the same smooth scroll.
  if (previousTarget !== null && Math.abs(previousTarget - target) < 2) return previousTarget
  panel.scrollTo({ top: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  return target
}

export function isTranscriptScrollKey(key: string) {
  return ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(key)
}
